import type { AppDispatch } from '@/redux/store'
import { setCwsDirect } from '../auth/slice'

export const redirectUser = (
  isFirstLogin: boolean,
  isOidc: boolean,
  dispatch: AppDispatch,
) => {
  if (window.history.length > 1 && !isFirstLogin) {
    if (isOidc) {
      window.history.go(-2)
      dispatch(setCwsDirect({ isOidc: false }))
      return
    }
    window.history.go(-1)
    return
  }
}
